import { SvgIconLink } from "./SvgIconLink";

export class ArrowBackLink extends SvgIconLink {
    protected get svgIcon() {
        return (
            <svg
                viewBox="0 0 64.2 57.2"
                fill="none"
                stroke="#14284F"
                strokeWidth="4"
                strokeLinecap="round"
                strokeMiterlimit="10"
            >
                <g>
                    <polyline points="29.6,2.1 3,28.7 29.4,55.2" />
                    <line x1="4.8" y1="28.7" x2="62.1" y2="28.7" />
                </g>
            </svg>
        );
    }
}
